
export interface QuarterRecord { version: string; quarter: string; }
export interface ScrapeRecord { version: string; }
export interface VersionLabel { version: string; label: string; }

export function buildVersionLabels(
  quarters: QuarterRecord[] = [],
  scrapes: ScrapeRecord[] = []
): VersionLabel[] {
  const quarterMap = new Map<string, string>();
  quarters.forEach(q => {
    if (!q.version || !q.quarter) return;
    const existing = quarterMap.get(q.quarter);
    if (!existing || q.version.localeCompare(existing) > 0) {
      quarterMap.set(q.quarter, q.version);
    }
  });

  const quarterEntries = Array.from(quarterMap.entries())
    .map(([quarter, version]) => ({ version, label: quarter }))
    .sort((a, b) => b.version.localeCompare(a.version));

  const latestVersion = scrapes
    .map(s => s.version)
    .sort((a, b) => b.localeCompare(a))[0] || quarterEntries[0]?.version;

  const result: VersionLabel[] = [];
  if (latestVersion) {
    result.push({ version: latestVersion, label: 'Latest' });
  }
  return result.concat(quarterEntries);
}
